import { HTTPClient } from "@/utils/request.hub";

export default {
  pf: ({ payload }) => HTTPClient.get(`/cpf/${payload.cpf}`),
  pj: ({ payload }) => HTTPClient.get(`/cnpj/${payload.cnpj}`),
  buscarCep: ({ payload }) => HTTPClient.get(`/cep/${payload.cep}`),
  Viabilidade: ({ payload }) =>
    HTTPClient.get(`/Viabilidade/Oi/${payload.cep}/${payload.numero}`),
};
